import React, { useState } from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import { useContactModal } from '../components/ContactModalContext';
import reg_event from '../img/hero_photo.png';
import SEOHead from '../components/SEOHead';

export default function SignUp() {
  const { strings } = useLanguage();
  const { openContact } = useContactModal();

  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    motivation: '',
  });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrorMessage('');

    try {
      const endpoint = process.env.REACT_APP_SIGNUP_URL;
      if (!endpoint) {
        throw new Error('SIGNUP_URL is not defined in environment variables.');
      }

      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        throw new Error('Failed to submit form.');
      }

      setSubmitted(true);
    } catch (err) {
      setErrorMessage(err.message || 'Произошла ошибка при отправке заявки.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <SEOHead routeId="register" slug="register" lang="ru" />
      <div>
        {/* Hero Section */}
        <section className="hero">
          <div className="hero-content">
            <div className="eyebrow">Членство · RPSwiss · 2026</div>
            <h1>
              Членство<br />в <em>RPSwiss</em>
            </h1>
            <p className="hero-sub">
              Сильное окружение<br />для жизни, карьеры и бизнеса в Швейцарии
            </p>
            <div className="hero-btns">
              <a href="#membership" className="btn-gold">Оставить заявку</a>
              <a href="https://instagram.com/rpswiss_ch" target="_blank" rel="noopener noreferrer" className="btn-outline">
                @rpswiss_ch
              </a>
            </div>
          </div>
          <div className="hero-photo">
            <img src={reg_event} alt="Мероприятие RPSwiss" />
          </div>
        </section>

        <div className="gold-line"></div>

        {/* Why Join RPSwiss Section */}
        <section className="section" id="why-join">
          <div className="section-tag">О сообществе</div>
          <div style={{ maxWidth: '780px' }}>
            <h2
              style={{
                fontFamily: "'Cormorant Garamond',serif",
                fontSize: 'clamp(28px,3.5vw,44px)',
                fontWeight: '300',
                color: 'var(--cream)',
                marginBottom: '20px',
              }}
            >
             Зачем примыкать к <em>RPSwiss</em>?
            </h2>
            <p
              style={{
                fontSize: '16px',
                lineHeight: '1.8',
                color: 'rgba(255, 255, 255, 0.85)',
                fontWeight: '300',
              }}
            >
              RPSwiss объединяет русскоязычных специалистов, предпринимателей, фрилансеров и 
              сотрудников компаний в Швейцарии из любых сфер и направлений. Участники получают 
              доступ к закрытой базе контактов, частным чатам сообщества, мастермайндам и 
              специальным скидкам на офлайн-мероприятия. Присоединяйтесь, чтобы расширить деловые 
              связи, найти новые карьерные возможности, завести полезные знакомства и стать частью 
              поддерживающего 
              профессионального экосообщества для жизни, работы и развития в Швейцарии.
            </p>
          </div>
        </section>

        <div className="gold-line"></div>

        {/* Membership & Refined Form Section */}
        <section className="section" id="membership">
          <div className="section-tag">Членство</div>

          <div
            className="membership-banner"
            style={{
              display: 'block',
              padding: '40px',
              backgroundColor: '#0c1520',
              border: '1px solid rgba(255, 255, 255, 0.08)',
              borderRadius: '4px',
            }}
          >
            <div style={{ maxWidth: '680px', marginBottom: '28px' }}>
              <div className="membership-sublabel" style={{ opacity: 0.7 }}>
                Подача заявки на участие
              </div>
              <h2
                style={{
                  fontFamily: "'Cormorant Garamond',serif",
                  fontSize: 'clamp(28px,3vw,42px)',
                  fontWeight: '300',
                  color: 'var(--cream)',
                  margin: '12px 0',
                }}
              >
                Присоединяйтесь к <em>RPSwiss</em>
              </h2>
              <p className="membership-desc" style={{ fontSize: '15px', color: 'rgba(255,255,255,0.7)', lineHeight: '1.7' }}>
                Заполните форму ниже, если хотите стать частью сообщества. Мы свяжемся с вами в рамках следующего набора участников.
              </p>
            </div>

            {submitted ? (
              <div
                style={{
                  padding: '28px',
                  border: '1px solid rgba(74, 222, 128, 0.4)',
                  background: 'rgba(74, 222, 128, 0.08)',
                  color: '#4ade80',
                  borderRadius: '4px',
                }}
              >
                <h3 style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: '24px', marginBottom: '8px', color: '#4ade80' }}>
                  Спасибо за вашу заявку!
                </h3>
                <p style={{ fontSize: '14px', color: '#86efac' }}>
                  Ваша заявка успешно отправлена. Мы получили ваши данные и обязательно свяжемся с вами в следующем цикле приема участников.
                </p>
              </div>
            ) : (
              <form onSubmit={handleSubmit} style={{ maxWidth: '680px' }}>
                <style>{`
                  .custom-form-input {
                    width: 100%;
                    background-color: rgba(255, 255, 255, 0.04) !important;
                    border: 1px solid rgba(255, 255, 255, 0.12) !important;
                    color: #ffffff !important;
                    padding: 12px 16px;
                    font-size: 14px;
                    border-radius: 4px;
                    outline: none;
                    transition: border-color 0.2s ease, background-color 0.2s ease;
                  }
                  .custom-form-input::placeholder {
                    color: rgba(255, 255, 255, 0.3);
                  }
                  .custom-form-input:focus {
                    border-color: rgba(255, 255, 255, 0.4) !important;
                    background-color: rgba(255, 255, 255, 0.07) !important;
                  }
                  .custom-form-label {
                    display: block;
                    font-size: 11px;
                    text-transform: uppercase;
                    letter-spacing: 0.1em;
                    color: rgba(255, 255, 255, 0.6);
                    margin-bottom: 8px;
                  }
                  .custom-submit-btn {
                    background: #ffffff;
                    color: #0c1520;
                    border: none;
                    padding: 14px 28px;
                    font-size: 11px;
                    font-weight: 600;
                    text-transform: uppercase;
                    letter-spacing: 0.15em;
                    cursor: pointer;
                    border-radius: 4px;
                    transition: opacity 0.2s ease;
                  }
                  .custom-submit-btn:hover {
                    opacity: 0.9;
                  }
                  .custom-submit-btn:disabled {
                    opacity: 0.5;
                    cursor: not-allowed;
                  }
                `}</style>

                {errorMessage && (
                  <div style={{ color: '#f87171', fontSize: '14px', marginBottom: '16px' }}>
                    {errorMessage}
                  </div>
                )}

                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: '20px', marginBottom: '20px' }}>
                  <div>
                    <label className="custom-form-label">Имя</label>
                    <input
                      type="text"
                      name="firstName"
                      required
                      value={formData.firstName}
                      onChange={handleChange}
                      className="custom-form-input"
                      placeholder="Иван"
                    />
                  </div>

                  <div>
                    <label className="custom-form-label">Фамилия</label>
                    <input
                      type="text"
                      name="lastName"
                      required
                      value={formData.lastName}
                      onChange={handleChange}
                      className="custom-form-input"
                      placeholder="Иванов"
                    />
                  </div>
                </div>

                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: '20px', marginBottom: '28px' }}>
                  <div>
                    <label className="custom-form-label">Электронная почта</label>
                    <input
                      type="email"
                      name="email"
                      required
                      value={formData.email}
                      onChange={handleChange}
                      className="custom-form-input"
                      placeholder="example@domain.ch"
                    />
                  </div>

                  <div>
                    <label className="custom-form-label">Номер телефона</label>
                    <input
                      type="tel"
                      name="phone"
                      required
                      value={formData.phone}
                      onChange={handleChange}
                      className="custom-form-input"
                      placeholder="+41 79 000 00 00"
                    />
                  </div>
                </div>

                <div style={{ marginBottom: '28px' }}>
                  <label className="custom-form-label">Почему вы хотите стать членом ассоциации и что вы можете принести сообществу</label>
                  <textarea
                    name="motivation"
                    required
                    maxLength={1000}
                    rows={5}
                    value={formData.motivation}
                    onChange={handleChange}
                    className="custom-form-input"
                    placeholder="Расскажите о своей мотивации и том, чем вы можете внести вклад в сообщество..."
                    style={{ minHeight: '120px', resize: 'vertical' }}
                  />
                  <div style={{ marginTop: '6px', fontSize: '11px', color: 'rgba(255,255,255,0.5)', letterSpacing: '0.04em' }}>
                    Максимум 1000 символов
                  </div>
                </div>

                <div>
                  <button type="submit" disabled={loading} className="custom-submit-btn">
                    {loading ? 'Отправка...' : 'Оставить заявку на членство'}
                  </button>
                </div>
              </form>
            )}
          </div>

          {/* Features Grid */}
          <div className="features-grid">
            <div className="feature-block">
              <div className="feature-block-label">Сеть и коммуникации</div>
              <ul className="feature-list">
                <li><strong>Закрытая база специалистов и компаний</strong> — поиск и прямой контакт (доступ по паролю на сайте)</li>
                <li><strong>Доступ в закрытый чат RPSwiss</strong> — запросы на специалистов, совместные проекты, коллаборации</li>
                <li>Рекомендации внутри сообщества и партнёрам ассоциации — под конкретные запросы</li>
              </ul>
            </div>
            <div className="feature-block">
              <div className="feature-block-label">Мероприятия</div>
              <ul className="feature-list">
                <li><strong>Онлайн-встречи и мастермайнды</strong> из разных сфер, обмен опытом, новые контакты. По мере роста сообщества количество событий будет пополняться.</li>
                <li>Доступ на <strong>4 офлайн-мероприятия</strong> ассоциации в год — скидка 20%</li>
                <li>Доступ на мероприятия от партнёров ассоциации — скидка 20%</li>
                <li>Скидка 20% на дополнительные открытые воркшопы и события ассоциации</li>
              </ul>
            </div>
          </div>

          <div className="features-grid" style={{ marginTop: '2px' }}>
            <div className="feature-block">
              <div className="feature-block-label">Видимость</div>
              <ul className="feature-list">
                <li>Профиль в закрытой базе участников</li>
                <li>Представление новых участников в сторис и официальных ресурсах ассоциации</li>
              </ul>
            </div>
            <div className="feature-block" style={{ display: 'flex', alignItems: 'center' }}>
              <div>
                <div className="feature-block-label">Для кого</div>
                <p style={{ fontSize: '13px', fontWeight: '300', color: 'var(--muted)', lineHeight: '1.8' }}>
                  Специалисты в найме, предприниматели, фрилансеры и все, кто говорит по-русски и строит свой путь в Швейцарии — вне зависимости от страны происхождения.
                </p>
              </div>
            </div>
          </div>
        </section>

        <div className="gold-line"></div>

        {/* Additional Services */}
        <section className="section" id="services">
          <div className="section-tag">Платные услуги</div>

          <div style={{ marginBottom: '40px', maxWidth: '680px' }}>
            <h2 style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 'clamp(26px,3vw,40px)', fontWeight: '300', color: 'var(--cream)', lineHeight: '1.25', marginBottom: '16px' }}>
              Дополнительные инструменты<br /><em>для продвижения</em>
            </h2>
            <p style={{ fontSize: '14px', fontWeight: '300', color: 'var(--muted)', lineHeight: '1.85' }}>
              Доступны всем участникам и компаниям — для размещения контента, вакансий и организации событий внутри сети.
            </p>
          </div>

          <div className="services-row">
            <div className="service-card">
              <div className="service-name">Реклама в чате или сторис</div>
              <div className="service-desc">Размещение в чате RPSwiss или в Instagram-сторис ассоциации</div>
            </div>
            <div className="service-card">
              <div className="service-name">Вакансия на портале</div>
              <div className="service-desc">Размещение на портале вакансий RPSwiss</div>
            </div>
            <div className="service-card">
              <div className="service-name">Событие в календарь</div>
              <div className="service-desc">Добавление мероприятия в календарь RPSwiss</div>
            </div>
            <div className="service-card">
              <div className="service-name">Консалтинг по ивентам</div>
              <div className="service-desc">Организация мероприятий совместно с командой RPSwiss</div>
            </div>
            <div className="service-card">
              <div className="service-name">Партнёрское мероприятие</div>
              <div className="service-desc">Совместное событие с RPSwiss — по договорённости</div>
            </div>
          </div>

          <div style={{ marginTop: '24px', padding: '28px 36px', border: '1px solid rgba(255,255,255,0.1)', background: 'rgba(255,255,255,0.02)', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '20px' }}>
            <p style={{ fontSize: '13px', fontWeight: '300', color: 'var(--muted)', lineHeight: '1.7' }}>
              Свяжитесь с нами, чтобы узнать подробности о стоимости дополнительного продвижения.
            </p>
            <button type="button" onClick={() => openContact()} className="btn-outline" style={{ whiteSpace: 'nowrap' }}>
              Написать нам
            </button>
          </div>
        </section>

        <div className="gold-line"></div>

        {/* Catalog Section */}
        <section className="section" id="catalog">
          <div className="section-tag">Каталог специалистов · Открытая база</div>

          <div className="catalog-box">
            <div className="catalog-left">
              <div className="catalog-eyebrow">Открытая база · Бесплатно</div>
              <h2>
                Ваш профиль<br />в <em>открытой базе</em>
              </h2>
              <p>Каталог специалистов RPSwiss — это открытая база, доступная всем желающим. Разместить профиль может любой специалист или компания.</p>

              <ol className="catalog-steps">
                <li className="catalog-step">
                  <div className="catalog-step-num">01</div>
                  <div className="catalog-step-text">
                    <strong>Заполните анкету</strong>
                    Расскажите о своей сфере, опыте, услугах или проекте — мы оформим ваш профиль.
                  </div>
                </li>
                <li className="catalog-step">
                  <div className="catalog-step-num">02</div>
                  <div className="catalog-step-text">
                    <strong>Попадите в каталог</strong>
                    Ваш профиль появляется в открытой базе — его найдут по специализации, имени или через поиск.
                  </div>
                </li>
                <li className="catalog-step">
                  <div className="catalog-step-num">03</div>
                  <div className="catalog-step-text">
                    <strong>Получайте запросы</strong>
                    Любой посетитель сайта и члены сообщества могут найти вас напрямую и обратиться с запросом.
                  </div>
                </li>
              </ol>
            </div>

            <div className="catalog-right">
              <div className="catalog-right-label">Что входит в профиль</div>
              <ul className="catalog-includes">
                <li>
                  <div className="catalog-includes-title">Имя и специализация</div>
                  <div className="catalog-includes-sub">Ваша профессия, сфера деятельности и ключевые компетенции</div>
                </li>
                <li>
                  <div className="catalog-includes-title">Контактные данные</div>
                  <div className="catalog-includes-sub">Прямой контакт для членов сообщества — почта, LinkedIn или сайт</div>
                </li>
                <li>
                  <div className="catalog-includes-title">О себе или компании</div>
                  <div className="catalog-includes-sub">Краткое описание опыта, проектов или услуг, которые вы предлагаете</div>
                </li>
                <li>
                  <div className="catalog-includes-title">Представление участников</div>
                  <div className="catalog-includes-sub">Новые участники анонсируются в соцсетях и сторис ассоциации</div>
                </li>
              </ul>

              <div style={{ padding: '24px 28px', border: '1px solid rgba(255,255,255,0.1)', background: 'rgba(255,255,255,0.02)' }}>
                <div style={{ fontSize: '11px', fontWeight: '600', letterSpacing: '0.2em', textTransform: 'uppercase', color: 'var(--cream)', marginBottom: '10px' }}>
                  Разместить профиль
                </div>
                <p style={{ fontSize: '13px', fontWeight: '300', color: 'var(--muted)', lineHeight: '1.75', marginBottom: '16px' }}>
                  Каталог открыт для всех. Заполните заявку — и мы добавим ваш профиль в базу специалистов RPSwiss.
                </p>
                <a href="/register_professional" target="_blank" className="btn-gold" style={{ fontSize: '10px', padding: '12px 28px' }}>
                  Заполнить заявку
                </a>
              </div>
            </div>
          </div>
        </section>

        <div className="gold-line"></div>

        {/* CTA Footer Section */}
        <div className="cta" id="join">
          <h2>Вступить в RPSwiss</h2>
          <p>Профессиональное сообщество русскоязычных специалистов в Швейцарии</p>
          <div className="cta-btns">
            <button type="button" onClick={() => openContact()} className="btn-gold">
              Написать нам
            </button>
            <a href="https://instagram.com/rpswiss_ch" target="_blank" rel="noopener noreferrer" className="btn-outline">
              @rpswiss_ch
            </a>
          </div>
        </div>
      </div>
    </>
  );
}